import ImportLayout from "components/import/Import";

function Import(props: any) {

    return (
        <ImportLayout props={props} />
    );
}

export default Import;